export default "__VITE_ASSET__ayR38rEd__"